import React from "react";

const ReceipeDetail = (props) => {
  let options = [];
  if (props.listInfo != undefined) {
    options.push({ value: "", info: "Select RMPM" });
    Object.keys(props.listInfo).forEach((key) => {
      options.push({
        value: props.listInfo[key],
        info: props.listInfo[key],
        selected: props.selected,
      });
    });
  } else {
    options.push({
      value: "",
      info: "No RMPM Found",
      selected: null,
    });
  }

  const removeList = (index) => {
    props.remove(index);
  };

  const handleInputChange = (e, index) => {
    props.listInputChange(e, index);
  };

  const rowProductId =
    props.listInfo?.product_id ?? props.listInfo?.product?.id ?? props.listInfo?.id;

  const stockErrorMessage =
    props.error?.message &&
    props.error?.product_ids &&
    Number(props.error.product_ids) === Number(rowProductId)
      ? props.error.message
      : null;

  return (
    <tr>
      <td>{props?.listInfo?.code ?? props.listInfo?.product?.code}</td>
      <td>
        {props.listInfo.name ?? props.listInfo?.product?.name}
        {stockErrorMessage ? (
          <div className="text-danger small mt-1">{stockErrorMessage}</div>
        ) : null}
      </td>
      <td>
        <input
          type="number"
          className="form-control"
          name="standard_qty"
          // onChange={(e) => handleInputChange(e, props.listSl)}
          value={props.listInfo.standard_qty || "0"}
          disabled
        />
        <p style={{ color: "red", textAlign: "center", marginTop: "10px" }}>
          {props.listInfo.standard_qty < 0.0001 ? "0 Are Not Allowed" : ""}
        </p>
      </td>
      <td>
        <input
          type="number"
          className="form-control"
          name="qty"
          onChange={(e) => handleInputChange(e, props.listSl)}
          value={props.listInfo.qty || "0"}
        />
        <p style={{ color: "red", textAlign: "center", marginTop: "10px" }}>
          {props.listInfo.qty < 0.0001 ? "0 Are Not Allowed" : ""}
        </p>
      </td>
      <td>
        <textarea
          className="form-control"
          name="remarks"
          value={props.listInfo.remarks || ""}
          onChange={(e) => handleInputChange(e, props.listSl)}
          placeholder="Remarks"
        ></textarea>
      </td>
      <td className="text-center">
        <button
          className="btn btn-danger btn-sm"
          onClick={() => removeList(props.listSl)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </td>
    </tr>
  );
};

export default ReceipeDetail;